import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslations, { EditTranslationsProps } from "../../editIndividualFields/editTranslations";
import { Helper } from "../../core/util/helper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { MultiSelect } from "../../core/components/multiSelect";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export default class EditTicketTypes extends React.Component<any, { gridData: KeyValuePair[] }> {
    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Config.translations.newLabel,
            type: ToolBarStandardButtonType.NEW,
            enabled: true
        },
        {
            caption: Config.translations.editLabel,
            type: ToolBarStandardButtonType.EDIT,
            enabled: true
        },
        {
            caption: Config.translations.deleteLabel,
            type: ToolBarStandardButtonType.DELETE,
            enabled: true
        }
    ];

    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        columns: [
            {
                title: Helper.getTranslation("Standard.Key"),
                field: "Key"
            }, {
                title: Helper.getTranslation("Standard.Typ"),
                field: "Value"
            }
        ]

    };
    private statusTypConnection: boolean;
    private metaData: Metadata;

    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        }
        this.initApp();
    }

    private initApp = async () => {
        const [metaData] = await Promise.all([
            Helper.getMetaData("editTicketType"),
            this.loadGridData()        
        ])
        this.metaData = metaData;
        this.setState({})
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass>("GeneralSettings/GetTicketTypes");
        if (result.Code == 0) {
            this.statusTypConnection = result.AdditionalData.StatusTypConnection;
            this.setState({ gridData: result.Data })
        }
    }


    private renderGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="ticketTypes"
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: KeyValuePair) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.create();
                break;
            case ToolBarStandardButtonType.EDIT:
                this.open(dataItem.Key);
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem.Key).then(this.loadGridData);
                break;
        }
    }

    private create = () => {
        const entity: TicketType = {
            Designations: [],
            GroupPermissions: [],
            RolePermissions:[],
            IsNew: true,
            IsWatchable: false,
            IsWatched: false,
            MainGroupPermissions: [],
            PKey: "",
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            UserPermissions: [],
            IndividualFields: {},
            TicketStatus: []
        }
        this.openSheet(entity)
    }

    private open = async (id: string) => {
        const result = await HTTPService.get<JsonResultClass>(`GeneralSettings/GetTicketTypeById?id=${id}`)
        this.openSheet(result.Data)
    }

    private delete = async (id: string) => {
        const isOK = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOK) {
            return false;
        }
        const result = await HTTPService.get<JsonResultClass>(`GeneralSettings/DeleteTicketType?id=${id}`);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message)
        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
        return result.Code === 0;
    }

    private openSheet = (entity: TicketType) => {
        const props: EditTicketTypeProps = {
            context: {
                contextType: "ticketType"
            },
            dataSources: {},
            entity: entity,
            isWindow: false,
            metadata: this.metaData,
            title: "",
            delete: this.delete,
            statusTypConnection: this.statusTypConnection
        }


        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this.loadGridData();
        });
        sheet.setTitle(Helper.getTranslation("WebSMS.GeneralSettings.Tickets.Tickettypen"));
        sheet.show(() => {
            sheet.mountContent(EditTicketType, props);
        });

    }

 
    render() {
        return (<div style={{ height: "300px", width: "100%" }}>{this.renderGrid()}</div>);
    }
};

class EditTicketType extends React.Component<EditTicketTypeProps, any>{
    common = new AppHelper();
    statusTypConnection: boolean;
    constructor(props: EditTicketTypeProps) {
        super(props)
        this.common.enableHooks = false;
        this.common.init(this);
        this.statusTypConnection = props.statusTypConnection;
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    renderGrid = () => {
        const props: EditTranslationsProps = {
            context: {},
            disabled: false,
            field: {
            },
            onChange: (_, value) => {
                this.handleFieldChange({ model: "entity.Designations" }, value)
            },
            value: this.props.entity.Designations
        }
        return <EditTranslations {...props}></EditTranslations>
    }

    renderConnectionGrid = () => {
        const onChange = (data: number[]) => {
            this.handleFieldChange({ model: "entity.TicketStatus" }, data)
        }

        return <EditStatusTypConnection data={this.props.entity.TicketStatus} onChange={onChange} ></EditStatusTypConnection>
    }

    save = async () => {
        const result = await HTTPService.post<JsonResultClass<TicketType>>("GeneralSettings/SaveTicketType", { model: this.props.entity });
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            Helper.updateEntity(this.props.entity, result.Data);
            this.props.entity.IsNew = false;
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.handlePostSave(result.Code === 0, false);
        this.setState({}, () =>{
            General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { event: "ReloadRights" });
        });
    }

    deleteType = async () => {
        const result = await this.props.delete(this.props.entity.PKey)
        if (result) {
            General.Sheet.Manager.getTopMostSheet().hide();
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditTicketTypeProps extends AppBaseProps {
    entity: TicketType;
    delete: (id: string) => Promise<boolean>;
    statusTypConnection: boolean;
}

interface TicketType extends Entity {
    PKey: string;
    Designations: KeyValuePair<number, string>[];
    UserPermissions: Permission[];
    GroupPermissions: Permission[];
    MainGroupPermissions: Permission[];
    RolePermissions: Permission[];
    TicketStatus: number[];
}

interface Permission {
    Id: string;
    EntityId: string;
    EntityLabel: string;
    Permission: number;
}

class EditStatusTypConnection extends React.Component<{ data: number[], onChange: (data: number[]) => void }, {}>{
    private factory = ComponentHelper.createFactory();
    private statuses: { Beschreibung: string, Prostatuskey: number }[];
    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: true,
        groupable: false,
        filterable: false,
        selectable: "multiple, row",
        resizable: true,
        scrollable: true,
        columns: [
            {
                title: Helper.getTranslation("Field.Vorgang.vorgangsstatus"),
                template: (id: number) => {
                    return `<div>${this.statuses.find(s => s.Prostatuskey == id).Beschreibung}</div>`;
                }
            }
        ]

    };

    constructor(props) {
        super(props)

        this.init();
    }

    private init = async () => {
        const result = await HTTPService.get<JsonResultClass>("GeneralSettings/GetTicketStatus");
        if (result.Code == 0) {
            this.statuses = result.Data;
        }
        this.setState({});
    }

    private sortData = (a: number, b: number) => {
        const tmp_a = this.statuses.find(s => s.Prostatuskey == a).Beschreibung;
        const tmp_b = this.statuses.find(s => s.Prostatuskey == b).Beschreibung;
        if (tmp_a < tmp_b)
            return -1;
        if (tmp_a > tmp_b)
            return 1;
        return 0;
    }

    private renderGrid = () => {
        const data = this.props.data.filter((id) => {
            const index = this.statuses.findIndex(f => f.Prostatuskey == id);
            return index > -1;
        }).sort(this.sortData)

        const buttons = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: true }
        ]
        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.gridOptions}
                    id="typeStatus"
                    standardButtons={buttons}
                    onClickStandardButton={this.onClick}
                />
            </div>
        );
    }

    private onClick = async (type: ToolBarStandardButtonType, selected: number|number[]) => {
        let data = [];
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const values = await this.getNewStatus()
                data = this.props.data.concat(values);
                this.props.onChange(data)
                break;
            case ToolBarStandardButtonType.DELETE:

                if (Array.isArray(selected)) {
                    data = this.props.data.filter((id) => {
                        const index = selected.findIndex(s => s == id);
                        return index == -1;
                    })
                } else {
                    data = this.props.data.filter(id => id != selected)
                }
                this.props.onChange(data)
                break;
        }
    }

    private getNewStatus = () => {
        return new Promise<number[]>((resolve) => {

            const targetElement = $("<div>");
            $("body").append(targetElement);

            const onClose = () => {
                targetElement.remove();
            };
            var values = [];
            const dialogProps: DialogProps = {
                title: "",
                actions: [
                    {
                        action: () => {
                            resolve([])
                        },
                        label: Helper.getTranslation("Standard.Abbrechen"),
                        primary: false
                    },
                    {
                        action: () => {
                            resolve(values)
                        },
                        label: Helper.getTranslation("Standard.OK"),
                        primary: true
                    }
                ],
                open: true,
                afterClose: onClose,
                width: 320
            };

            const props = this.factory.getDefaultMultiSelectProps();
            props.onChange = (_, items) => {
                values = items.map(item => item.Prostatuskey);
            }
            const dataSource = this.statuses.filter((item) => {
                const index = this.props.data.findIndex(id => item.Prostatuskey == id);
                return index == -1;
            });
            props.dataSource = dataSource;
            props.field.dataTextField = "Beschreibung";
            props.field.dataValueField = "Prostatuskey";

            ReactDOM.render(
                <>
                    <Dialog {...dialogProps} >
                        <MultiSelect {...props} />
                    </Dialog>
                </>, targetElement[0]
            );


        })
    }


    render() {
        return Helper.hasValue(this.statuses) ? this.renderGrid() : null;
    }
}

